import { cloneElement, FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

export const HeaderButtonControl: FC<{
  children: ReactElement<PropsWithChildren<{ className: string }>>
}> = ({ children }) => {
  return cloneElement(
    children,
    {
      className: classNames('rounded py-2 shadow px-3.5 text-sm', children.props.className),
    },
    children.props.children,
  )
}
